var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.824 5.035c-.305.051-.592.284-.737.597l-.07.151v8.434l.092.188c.107.218.299.405.52.507.15.069.202.072 1.754.082 2.302.015 2.896-.035 3.717-.315a4.6 4.6 0 0 0 1.589-.918c.442-.391.708-.738.935-1.218.295-.622.375-1.165.375-2.543 0-.449-.014-.989-.032-1.2-.077-.93-.417-1.699-1.023-2.314-.879-.893-1.947-1.357-3.337-1.452-.574-.039-3.55-.039-3.783.001m4.388 1.042c.33.071.8.228 1.029.343.716.358 1.299.942 1.554 1.557.188.452.205.624.205 2.023 0 1.401-.017 1.571-.207 2.027-.322.776-1.073 1.422-2.024 1.741-.63.211-.633.211-2.794.224L7 14.003V5.997l1.975.011c1.707.01 2.011.02 2.237.069",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.b3634516465bbbf6e942c5f51a2f1f2f.svg";
export { ForwardRef as ReactComponent };